export const APPROVALS_LIVE_DOC_PUBLISH_MODAL_SOURCE = 'approvals-live-doc';
